import { useEffect, useState } from "react";
import { api } from "../../lib/api";

export function AdminContact() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/contact").then((r) => setItems(r.data)); }, []);
    return (
        <div data-testid="admin-contact">
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-2">Inbox</div>
            <h1 className="h-display text-4xl mb-8">Messages</h1>
            <div className="space-y-3">
                {items.map((m) => (
                    <div key={m.id} className="card-flat p-5" data-testid={`msg-${m.id}`}>
                        <div className="flex justify-between text-xs text-ink tracking-widest uppercase">
                            <span>{m.name} &middot; {m.email}</span>
                            <span>{new Date(m.created_at).toLocaleString()}</span>
                        </div>
                        <div className="h-display text-lg mt-2">{m.subject}</div>
                        <p className="text-white/80 mt-2 leading-relaxed whitespace-pre-line">{m.message}</p>
                    </div>
                ))}
                {items.length === 0 && <div className="card-flat p-12 text-center text-ink">Inbox empty.</div>}
            </div>
        </div>
    );
}


export function AdminPressInquiries() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/press-inquiry").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const toggleHandled = async (m) => {
        await api.put(`/press-inquiry/${m.id}/handled?handled=${!m.handled}`);
        load();
    };

    return (
        <div data-testid="admin-press">
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-2">Press</div>
            <h1 className="h-display text-4xl mb-8">Press Inquiries</h1>
            <div className="space-y-3">
                {items.map((m) => (
                    <div key={m.id} className="card-flat p-5" data-testid={`press-${m.id}`}>
                        <div className="flex justify-between text-xs text-ink tracking-widest uppercase">
                            <span>{m.name}{m.organization ? ` · ${m.organization}` : ""} · {m.email}</span>
                            <span>{new Date(m.created_at).toLocaleString()}</span>
                        </div>
                        <div className="h-display text-lg mt-2">{m.subject}</div>
                        <div className="text-xs text-ink mt-1 flex flex-wrap gap-x-4">
                            {m.phone && <span>📞 {m.phone}</span>}
                            {m.deadline && <span>⏰ Deadline: {m.deadline}</span>}
                        </div>
                        <p className="text-white/80 mt-3 leading-relaxed whitespace-pre-line">{m.message}</p>
                        <button
                            type="button"
                            onClick={() => toggleHandled(m)}
                            data-testid={`press-toggle-${m.id}`}
                            className={`mt-4 text-[10px] tracking-[0.3em] uppercase font-bold ${m.handled ? "text-ink hover:text-white" : "text-gold hover:text-gold-bright"}`}
                        >
                            {m.handled ? "✓ Handled — Reopen" : "Mark Handled"}
                        </button>
                    </div>
                ))}
                {items.length === 0 && <div className="card-flat p-12 text-center text-ink">No press inquiries yet.</div>}
            </div>
        </div>
    );
}

export function AdminNewsletter() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/newsletter").then((r) => setItems(r.data)); }, []);
    return (
        <div data-testid="admin-newsletter">
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-2">Royal Dispatch</div>
            <h1 className="h-display text-4xl mb-8">Newsletter Subscribers ({items.length})</h1>
            <div className="card-flat overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-bg-soft border-b border-line"><tr>
                        <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Email</th>
                        <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Name</th>
                        <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Source</th>
                        <th className="text-left p-3 text-[10px] uppercase tracking-widest text-ink">Subscribed</th>
                    </tr></thead>
                    <tbody>
                        {items.map((s) => (
                            <tr key={s.id} className="border-t border-line" data-testid={`sub-${s.id}`}>
                                <td className="p-3">{s.email}</td>
                                <td className="p-3 text-ink">{s.name || "—"}</td>
                                <td className="p-3 text-ink text-xs uppercase tracking-widest">{s.source || "footer"}</td>
                                <td className="p-3 text-ink">{new Date(s.created_at).toLocaleDateString()}</td>
                            </tr>
                        ))}
                        {items.length === 0 && <tr><td colSpan={4} className="p-12 text-center text-ink">No subscribers yet.</td></tr>}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
